import { ControlInterface } from 'edocatbase/Form';

const { Datepicker, TextField } = window.Edocat.Components;

import { getBooleanValue, getTimeFormat } from '../../lib/date';
import { ReduxComponentInterface } from 'edocatbase/Global';

const moment = window.moment;

interface DateDiffInterface extends ControlInterface, ReduxComponentInterface {
	fieldToWatchValue: any;
}

class DateDiff extends React.PureComponent<DateDiffInterface> {
	private inputRef = React.createRef<HTMLInputElement>();

	onDateChange = (value: any) => {
		const { onChange, name, dirty, fieldToWatchValue } = this.props;

		const changeValue = {
			date: value,
			days: moment(value).startOf('day').diff(moment(fieldToWatchValue).startOf('day'), 'days') || 1,
		};

		onChange([name], changeValue, dirty);
	};

	onDaysChange = (event: React.ChangeEvent) => {
		event.preventDefault();
		let { value } = event.target as HTMLInputElement;
		const element = this.inputRef.current;

		if (!value && element) {
			element.select();
		}

		if (value && `${value}`.startsWith('0')) {
			value = value.substr(1);
		}

		const { onChange, name, dirty, fieldToWatchValue } = this.props;
		const changeValue = {
			date: moment(fieldToWatchValue).startOf('day').add(value, 'days'),
			days: value,
		};

		onChange([name], changeValue, dirty);
	};

	onBlur = () => {
		const { onBlur, name, value, dirty } = this.props;
		// @ts-ignore
		onBlur(name, value, dirty);
	};

	onInputFocus = () => {
		const element = this.inputRef.current;
		if (element) element.select();
	};

	render() {
		const {
			label,
			disabled,
			control: {
				params: { showTime, dateFormat, timeFormat },
			},
			mandatory,
			name,
			className,
			title,
			value,
			fieldToWatchValue,
			placeholder,
		} = this.props;

		const minDate = this.props.control.params.minDate || fieldToWatchValue;

		const valueDate = value?.date ?? null;
		const valueDays = value?.days ?? 0;
		return (
			<div className={`form-row row-${name} date-diff-row`}>
				<label htmlFor={name}>
					{label}
					{mandatory ? '*' : ''}
					<span className="error-title">{title}</span>
				</label>
				<TextField
					mandatory={mandatory}
					variant={'outlined'}
					type="number"
					inputRef={this.inputRef}
					onFocus={this.onInputFocus}
					onChange={this.onDaysChange}
					value={valueDays}
					min={1}
					fullWidth={false}
				/>
				<Datepicker
					className={className}
					dateFormat={dateFormat}
					disabled={disabled}
					isClearable={!mandatory}
					minDate={minDate}
					name={name}
					onBlur={this.onBlur}
					onChange={this.onDateChange}
					selected={valueDate}
					showTimeSelect={getBooleanValue(showTime)}
					timeFormat={getTimeFormat(showTime, timeFormat)}
					placeholder={placeholder}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state: any, props: any) => {
	const fieldToWatch = state?.[props?.formInstanceId]?.form?.fields?.[props?.control?.params?.fieldToWatch] ?? null;
	const fieldToWatchValue = fieldToWatch?.value ?? null;

	return {
		fieldToWatch,
		fieldToWatchValue,
	};
};

export default window.reactRedux.connect(mapStateToProps, null)(DateDiff);
